// Marks that this visit has already been welcomed. Session-scoped on purpose: a returning
// visitor gets the doorway again on their next visit, but not on every click of the logo.
export const WELCOME_SEEN_KEY = 'mama-africa-welcomed';
